export var getDefaultStyleSheet = _ref => {
  var {
    backgroundColorToken,
    backgroundColorTokenArgs,
    cornerRadiusToken,
    designContext,
    paddingToken
  } = _ref;
  return {
    rootStyle: {
      backgroundColor: designContext.get(backgroundColorToken, backgroundColorTokenArgs).toString(),
      borderWidth: 0,
      borderRadius: designContext.get(cornerRadiusToken).value(),
      paddingTop: designContext.get(paddingToken, {
        side: 'top'
      }).value(),
      paddingBottom: designContext.get(paddingToken, {
        side: 'bottom'
      }).value(),
      paddingLeft: designContext.get(paddingToken, {
        side: 'left'
      }).value(),
      paddingRight: designContext.get(paddingToken, {
        side: 'right'
      }).value(),
      width: '100%'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map